import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Input, Modal } from "ui";

import { useRejectReturn } from "../../../apis";
import { returnRejectionFormSchema } from "../../../helpers";
import { ReturnRejectFormValues } from "../../../returns.types";
import { RejectModalProps } from "./RejectModal.types";

import styles from "./RejectModal.module.scss";

const REJECT_RETURN_FORM_ID = "REJECT_RETURN_FORM_ID";

export const RejectModal = ({
  returnId,
  isOpen,
  onClose,
  refetchDetails,
  refetchReturns
}: RejectModalProps) => {
  const { t } = useTranslation();
  const { register, handleSubmit, formState } = useForm<ReturnRejectFormValues>(
    {
      defaultValues: {
        orderId: returnId,
        cancellationReason: ""
      },
      resolver: yupResolver(returnRejectionFormSchema)
    }
  );

  const rejectReturn = useRejectReturn({
    onSuccess: () => {
      toast.success(t("Return has been successfully rejected"));

      refetchDetails?.();
      refetchReturns();
      onClose();
    }
  });

  const submitReturnRejection = (values: ReturnRejectFormValues) => {
    rejectReturn.mutate(values);
  };

  return (
    <Modal
      isOpen={isOpen}
      title={t("Reject return")}
      formId={REJECT_RETURN_FORM_ID}
      okText={t("Reject")}
      contentClassName={styles.rejectModal}
      onClose={onClose}
    >
      <p className={styles.rejectModal_text}>
        {t("Describe the reason for return rejection")}
      </p>

      <form
        id={REJECT_RETURN_FORM_ID}
        onSubmit={handleSubmit(submitReturnRejection)}
      >
        <Input
          asTag="textarea"
          placeholder={t("Message")}
          errorMessage={formState.errors.cancellationReason?.message}
          {...register("cancellationReason")}
        />
      </form>
    </Modal>
  );
};
